import { render, staticRenderFns } from "./ExperimentResViewer.vue?vue&type=template&id=7c688a3a&scoped=true&"
import script from "./ExperimentResViewer.vue?vue&type=script&lang=ts&"
export * from "./ExperimentResViewer.vue?vue&type=script&lang=ts&"
import style0 from "./ExperimentResViewer.vue?vue&type=style&index=0&id=7c688a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c688a3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
